const Faqs = {
  faqsPath: () => '/api/faqs',
};

export default Faqs;
